var map = {
	"./finland.json": [
		97398,
		471
	],
	"./great_britain.json": [
		45479,
		354
	],
	"./norway.json": [
		74276,
		401
	],
	"./slovakia.json": [
		78222,
		487
	],
	"./spain.json": [
		56651,
		46
	],
	"./sweden.json": [
		56050,
		423
	],
	"./switzerland.json": [
		92783,
		918
	],
	"./tsvetkov_mountains.json": [
		23065,
		143
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 77149;
module.exports = webpackAsyncContext;